import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Image,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * Headline Banner component
 *
 * @param {Object} - props.custom - Image Link.
 * @param {string} - props.text_subline - Sub Line.
 * @param {string} - props.text_headline - Head Line.
 * @returns {React.ReactElement} - headline-banner component.
 */
export const HeadLineBanner = ({custom, text_subline, text_headline}) => {
    const styles = useMultiStyleConfig('containerStyles')
    const imageURL = custom?.image?.disBaseLink

    return (
        <Box test-data-id="headline-banner" {...styles.containerStyles}>
            {imageURL && <Image src={imageURL} alt={'headline-banner-image'} />}
            <Box>
                {text_headline && (
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: text_headline
                        }}
                        sx={{
                            fontSize: '28px',
                            lineHeight: '33.3px',
                            mb: '2',
                            fontWeight: 'medium'
                        }}
                    />
                )}
                {text_subline && (
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: text_subline
                        }}
                        sx={{
                            fontSize: 'md',
                            lineHeight: '6',
                            mb: '4'
                        }}
                    />
                )}
            </Box>
        </Box>
    )
}

HeadLineBanner.propTypes = {
    custom: PropTypes.object,
    text_subline: PropTypes.string,
    text_headline: PropTypes.string
}

export default HeadLineBanner
